<template>
    <PromotionForm :promotion="promotion" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import PromotionForm from './PromotionForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    PromotionForm
  },
  data() {
    return {
      promotion:null,
      loaded:false,
    }
  },
  props:['language'],
  methods:{
    
  },
  async mounted()
  {
    this.promotion=await APIRequest.detail('promotions',this.$route.params.id)
    this.loaded=true
  }
}
</script>
